import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        countries: '=',
        directManagers: '=',
        siteId: '='
    },
    template: `
        <div class="col00">
            <form role="form" class="form-horizontal" ng-submit="vm.save()">
                <h1>{{ 'user.Edit user' | translate }}</h1>
                <div class="person01">
                    <div class="txt">
                    <form-wrapper form="vm.form">
                        <form-row error="vm.form.errors.drls" ng-if="vm.lodash.isString(vm.form.errors.drls)">
                            <form-row-error></form-row-error>
                        </form-row>
                        <form-row error="vm.form.errors.firstName">
                            <label class="label">{{ 'user.First name' | translate }} *</label>
                            <div class="items">
                                <input ng-model="vm.form.model.firstName" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.lastName">
                            <label class="label">{{ 'user.Last name' | translate }} *</label>
                            <div class="items">
                                <input ng-model="vm.form.model.lastName" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.country">
                            <label class="label">{{ 'user.Country' | translate }} *</label>
                            <div class="items">
                                <ui-select ng-model="vm.form.model.country" theme="selectize" title="{{ 'user.Country' | translate }}">
                                    <ui-select-match placeholder="{{ 'user.Select or search a country in the list...' | translate }}"
                                    >{{$select.selected.label}}</ui-select-match>
                                    <ui-select-choices repeat="country.key as country in vm.countries | filter: $select.search">
                                        <span ng-bind-html="country.label | highlight: $select.search"></span>
                                    </ui-select-choices>
                                </ui-select>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.coursyLanguage">
                          <label class="label">{{ 'user.Language' | translate }} *</label>
                          <div class="items">
                            <select class="form-control"
                                    ng-model="vm.form.model.coursyLanguage"
                                    ng-options="code as vm.COMPANY_LANGUAGE_ENUM.LABELS[code]
                                                for (key, code) in vm.companyLanguages
                                                track by code">
                            </select>
                            <form-row-error></form-row-error>
                          </div>
                        </form-row>
                        <form-row error="vm.form.errors.timezone">
                            <label class="label">{{ 'user.Timezone' | translate }} *</label>
                                <div class="items">
                                    <form-row-error></form-row-error>
                                    <select class="form-control" ng-model="vm.form.model.timezone">
                                        <option
                                            ng-repeat="(timezone, label) in vm.TIMEZONE_ENUM.LABELS"
                                            value="{{ vm.TIMEZONE_ENUM.KEYS[timezone] }}">
                                            {{ label }}
                                        </option>
                                    </select>
                                </div>
                        </form-row>
                        <form-row error="vm.form.errors.idCode">
                            <label class="label">{{ 'user.Personal code' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.idCode" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.primaryEmail">
                            <label class="label">{{ 'user.Email' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.primaryEmail" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.contactPhone">
                            <label class="label">{{ 'user.Phone' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.contactPhone" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.directManagerIds">
                            <label class="label">{{ 'user.Employees direct manager' | translate }}</label>
                            <div class="items">
                                <tags-input
                                    key-property="id"
                                    display-property="displayName"
                                    add-from-autocomplete-only="false"
                                    replace-spaces-with-dashes="false"
                                    ng-model="vm.chosenManagers"
                                    text="vm.tagText"
                                    on-tag-adding="vm.addTag($tag)"
                                    on-invalid-tag="vm.invalidTag($tag)"
                                    ng-blur="vm.blurTag()"
                                    tag-class="vm.getDmTagClass($tag)"
                                    placeholder="{{ 'user.Add direct manager' | translate }}">
                                    <auto-complete min-length="1" source="vm.filterManagers($query)"></auto-complete>
                                </tags-input>
                                <span ng-if="vm.tagError" class="has-error">{{ 'user.Invalid direct manager' | translate }}</span>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.workingSince">
                            <label class="label">{{ 'user.Working since' | translate }} *</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.form.model.workingSince"></datepicker-api>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.isDirectManager" ng-if="vm.PrivilegeService.isCompanyAdmin()">
                            <span class="label">{{ 'user.Direct manager' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input ng-disabled="true" type="checkbox" name="switch" ng-model="vm.form.model.isDirectManager" ng-value="true" checked="">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.hasAllLearnersReportViewPrivilege"
                         ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.form.model.isDirectManager">
                            <span class="label">{{ 'user.Allow to monitor learner progress for all site users' | translate }}
                                <span class="tooltip-icon"
                                    uib-tooltip="{{ 'user.Monitor learner progress for all site tooltip' | translate }}"
                                    tooltip-placement="top-right">?</span>
                           </span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.hasAllLearnersReportViewPrivilege" ng-value="true" checked="">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.hasMyEmployeeManagePrivilege"
                         ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.form.model.isDirectManager">
                            <span class="label">{{ 'user.Can add employees' | translate }}</span>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" name="switch" ng-model="vm.form.model.hasMyEmployeeManagePrivilege" ng-value="true" checked="">
                                    <span>{{ 'general.Yes' | translate }}</span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <!-- <form-row error="vm.form.errors.status">
                            <label class="label todo">{{ 'user.Status' | translate }}</label>
                            <div class="items todo">
                                <select class="form-control" ng-model="vm.form.model.status" ng-disabled="vm.user.isExternalUser">
                                    <option ng-repeat="key in vm.USER_STATUS_ENUM.KEYS" value="{{ vm.USER_STATUS_ENUM.KEYS[key] }}">
                                        {{ vm.USER_STATUS_ENUM.LABELS[key] }}
                                    </option>
                                </select>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row> -->
                    </form-wrapper>
                    </div>
                </div>
                <ul class="actions01">
                    <li><a ng-click="vm.save()" class="btn main">{{ 'general.Save' | translate }}</a></li>
                    <li><a ui-sref="authorized.user.employee.detail({id: vm.user.id})" class="btn discrete" >{{ 'general.Cancel' | translate }}</a></li>
                </ul>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
    `
})
export default class {
    constructor ($state, $translate, lodash, toastr, FormFactory, USER_STATUS_ENUM, USER_CUSTOM_ERROR_ENUM, COMPANY_LANGUAGE_ENUM,
                 TIMEZONE_ENUM, TokenService, UserManagerService, ModalService, PrivilegeService) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.USER_CUSTOM_ERROR_ENUM = USER_CUSTOM_ERROR_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.TIMEZONE_ENUM = TIMEZONE_ENUM;
        this.TokenService = TokenService;
        this.UserManagerService = UserManagerService;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.user);
        this.companyLanguages = this.TokenService.getCompanySupportedLanguages();
        this.chosenManagers = [];
        if (this.user.id) {
            this.chosenManagers = this.UserManagerService.getChosenManagers(this.user, this.directManagers);
        }

        if (this.user.externalId) {
            this.toastr.warning(this.$translate.instant('user.External user change'));
        }
    }

    /**
     * Check to make sure direct manager tag is actually in direct managers array
     * @param tag object
     * @returns {boolean}
     */
    addTag (tag) {
        const isValid = this.directManagers.some(manager => manager.displayName === tag.displayName);
        this.tagError = !isValid;
        return isValid;
    }

    /**
     * Set tagError when tags input loses focus
     */
    blurTag () {
        // we use double negative here because tagText can be either undefined or ''
        this.tagError = !!this.tagText;
    }

    beforeSave () {
        this.form.model.directManagerIds = this.chosenManagers.map((manager) => manager.id);
    }

    save (validateNotifications = true) {
        if (this.tagError) {
            return;
        }
        const additionalGetParams = validateNotifications ? { validateNotifications: true } : { validateNotifications: null };

        this.beforeSave();
        this.form.save(additionalGetParams)
            .then((model) => {
                this.toastr.success(this.$translate.instant('user.User updated', { name: model.displayName }));
                this.$state.go('authorized.user.employee.detail', { id: model.id });
            }).catch((response) => {
                if (this.lodash.isEmpty(response.data) || !Array.isArray(response.data)) {
                    return;
                }

                let hasOnlyNotifications = true;
                // if we have any other than CUSTOM_ERROR
                response.data.forEach((error) => {
                    if (!this.USER_CUSTOM_ERROR_ENUM.KEYS[error.field]) {
                        hasOnlyNotifications = false;
                    }
                });

                if (!hasOnlyNotifications) {
                    return;
                }

                const addConfirmMessage = this.$translate.instant('user.name_already_exist_notification');
                this.form.errors = {};
                this.form.invalid = false;
                this.ModalService.confirm(addConfirmMessage, 'medium').then(() => this.save(false));
            });
    }

    filterManagers (value) {
        return this.directManagers.filter((field) => this.lodash.includes(field.displayName.toUpperCase(), value.toUpperCase()));
    }

    getDmTagClass (tag) {
        return tag.isManuallyAdded ? '' : 'remove-button-disable';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/edit/index.js